import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Section from '../../../components/Section';
import { Form, Button, Input, Message, Modal, Header } from 'semantic-ui-react';
import moment from 'moment';

class ChatSettingsSection extends Component {
	constructor(props) {
		super(props);
		const { actions, admin } = props;
		this.state = {
			filled: false,
			mode: admin.chatSchedule.mode,
			startTime: admin.chatSchedule.startTime,
			endTime: admin.chatSchedule.endTime,
			closedWeekends: admin.chatSchedule.closedWeekends,
			showSuccess: false
		};
		this.onFieldChange = this.onFieldChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onHideSuccess = this.onHideSuccess.bind(this);
		actions.fetchChatOptions();
		this.hasUpdated = false;
	}

	componentDidUpdate() {
		const { admin } = this.props;
		if (admin.chatSchedule.id != null && this.state.filled === false) {
			this.setState({
				filled: true,
				mode: admin.chatSchedule.mode,
				startTime: moment(admin.chatSchedule.startTime).format('h:mm A'),
				endTime: moment(admin.chatSchedule.endTime).format('h:mm A'),
				closedWeekends: admin.chatSchedule.closedWeekends
			});
		}
	}

	onFieldChange(_, { name, value, checked }) {
		if (value) this.setState({ [name]: value });
		else this.setState({ [name]: checked });
	}

	async onSave() {
		const { actions } = this.props;
		try {
			await actions.updateChatOptionsRequest(this.state);
			this.setState({ showSuccess: true });
		} catch (error) {
			console.log(error);
		}
	}

	onHideSuccess() {
		this.setState({ showSuccess: false });
	}

	render() {
		const { mode, startTime, endTime, closedWeekends, showSuccess } = this.state;

		let errorMessage;
		if (this.props.admin.error) {
			const content = Array.isArray(this.props.admin.error) ? this.props.admin.error.map((e, index) => <div key={index}>{`${e}`}</div>) : this.props.admin.error;
			errorMessage = <Message error header='Chat Save Failed' content={content} />;
		}

		return (
			<Section name='chat' title='Chat Management' color='red' mobileShow={this.props.mobileShow}>
				<Modal open={showSuccess}>
					<Modal.Header>Chat Options</Modal.Header>
					<Modal.Content>
						<Header as='h1' style={{ textAlign: 'center' }}>
							Chat Options Successfully Updated!
						</Header>
					</Modal.Content>
					<Modal.Actions>
						<Button onClick={this.onHideSuccess}>Close</Button>
					</Modal.Actions>
				</Modal>
				<div className='center'>
					<Button.Group>
						<Button name='mode' value={1} onClick={this.onFieldChange} color={mode === 1 ? 'blue' : null}>
							Always On
						</Button>
						<Button.Or />
						<Button name='mode' value={2} onClick={this.onFieldChange} color={mode === 2 ? 'blue' : null}>
							Always Off
						</Button>
						<Button.Or />
						<Button name='mode' value={3} onClick={this.onFieldChange} color={mode === 3 ? 'blue' : null}>
							Use Schedule
						</Button>
					</Button.Group>
				</div>

				{mode === 3 ? (
					<div>
						<Form error>
							<Form.Group>
								<Form.Field>
									<label>Daily Start Time</label>
									<Input name='startTime' onChange={this.onFieldChange} value={startTime} placeholder='Start Time' />
								</Form.Field>
								<Form.Field>
									<label>Daily End Time</label>
									<Input name='endTime' onChange={this.onFieldChange} value={endTime} placeholder='End Time' />
								</Form.Field>
							</Form.Group>
							<Form.Group>
								<Form.Field>
									<label>Closed Weekends</label>
									<Form.Checkbox onChange={this.onFieldChange} name='closedWeekends' checked={closedWeekends} placeholder='Closed weekends'></Form.Checkbox>
								</Form.Field>
							</Form.Group>
						</Form>
					</div>
				) : null}
				<Form.Group>
					<Form.Button primary content='Save' onClick={this.onSave} />
				</Form.Group>
				{errorMessage}
			</Section>
		);
	}
}

ChatSettingsSection.propTypes = {
	actions: PropTypes.object.isRequired,
	admin: PropTypes.object.isRequired
};

export default ChatSettingsSection;
